<template>
  <div class="promotion-table table-responsive overflow-auto">
    <table class="table table-bordered table-vertical-center b-table">
      <thead>
      <tr>
        <th class="w-80px">Mã quà tặng</th>
        <th class="min-w-250px">Tên quà tặng</th>
        <th class="w-120px">Mã khách hàng</th>
        <th class="w-130px">Khách hàng</th>
        <th class="w-140px">Số điện thoại</th>
        <th class="w-100px">Mã hợp đồng</th>
        <th class="w-120px">Trạng thái</th>
        <th class="w-140px">Thời gian tạo</th>
        <th class="w-140px">Mốc theo dõi</th>
        <th class="w-105px text-center">Hành động</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="records.length > 0">
        <tr v-for="item in records" :key="item.id">
          <td>{{ item.giftCode }}</td>
          <td>
            <span class="promotion-table__gift-name">{{ item.giftName }}</span>
          </td>
          <td>{{ item.customerId }}</td>
          <td>{{ item.customerName }}</td>
          <td>{{ item.customerPhone }}</td>
          <td>{{ item.contractCode }}</td>
          <td>
            <span class="promotion-status" :class="statusClass(item.statusCode)">
              {{ item.status }}
            </span>
          </td>
          <td>{{ item.createdAt }}</td>
          <td>{{ item.followAt }}</td>
          <td class="text-center">
            <button
                v-for="actionItem in item.actionItems"
                :key="`${item.id}-${actionItem.action}`"
                class="btn btn-icon btn-xs mr-2"
                :class="actionItem.className"
                :title="actionItem.label"
                type="button"
                @click="$emit('change-status', item, actionItem)"
            >
              <i :class="actionItem.icon"></i>
            </button>
          </td>
        </tr>
      </template>
      <tr v-else>
        <td colspan="10" class="text-center">Chưa có dữ liệu</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { GIFT_STATUS } from "@/view/pages/logistics/model/ManageGiftProgramModel";

export default {
  name: 'MangeGiftProgramTable',
  props: {
    records: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    statusClass(statusCode) {
      switch (Number(statusCode)) {
        case GIFT_STATUS.NOT_ACTIVATED:
          return 'promotion-status--inactive'
        case GIFT_STATUS.PENDING_SEND:
          return 'promotion-status--need-send'
        case GIFT_STATUS.SENT:
          return 'promotion-status--sent'
        case GIFT_STATUS.PENDING_PROCESS:
          return 'promotion-status--warning'
        case GIFT_STATUS.CANCELLED:
          return 'promotion-status--cancelled'
        default:
          return 'promotion-status--inactive'
      }
    }
  }
}
</script>

<style scoped>
.promotion-table {
  padding-bottom: 18px;
}

.promotion-table .table {
  margin-bottom: 0;
  text-align: left;
}

.promotion-table th {
  background: #f8f8f8;
  border-color: #c9ced8;
  color: #1f2933;
  font-size: 12px;
  font-weight: 600;
  height: 34px;
  padding: 8px 12px;
  text-align: left;
  white-space: nowrap;
}

.promotion-table td {
  border-color: #c9ced8;
  color: #111827;
  font-size: 12px;
  height: 34px;
  padding: 7px 12px;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
}

.promotion-table th.text-center,
.promotion-table td.text-center {
  text-align: center;
}

.promotion-table__gift-name {
  display: block;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.promotion-status {
  border-radius: 3px;
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  line-height: 20px;
  padding: 0 8px;
  white-space: nowrap;
}

.promotion-status--inactive {
  background: #E0E6EE;
  color: #1f2933;
}

.promotion-status--need-send {
  background: #0066FF;
  color: #ffffff;
}

.promotion-status--sent {
  background: #006B04;
  color: #ffffff;
}

.promotion-status--warning {
  background: #FFBB00;
  color: #111827;
}

.promotion-status--cancelled {
  background: #FF7D7D;
  color: black;
}
</style>
